
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container">
  <user-selection #userSelection [pageSize]="5" [projectId]="workflowTargetInfo.projectId" [disableAll]="isLocked || !workflowTargetInfo.correctRole"></user-selection>
</div>